import { cn } from "@/lib/utils";
import Starter from "./Starter";

interface Props {
  className?: string;
}

export default function Starters({ className }: Props) {
  const starters = [
    {
      label: "Improve HCP engagement",
      message: "How can I improve engagement on my HCP portal?",
      command: undefined,
      icon: undefined,
    },
    {
      label: "How to use AI in pharma",
      message: "What are smart ways to use AI in pharma websites and portals?",
      command: undefined,
      icon: undefined,
    },
    {
      label: "Top portal features",
      message: "What are the must-have features for a patient or HCP portal?",
      command: undefined,
      icon: undefined,
    },
    {
      label: "Modernize my pharma portal",
      message: "I want to modernize my pharma portal—where should I start?",
      command: undefined,
      icon: undefined,
    },
  ];

  if (!starters?.length) return null;

  return (
    <div
      id="starters"
      className={cn("flex gap-2 justify-center flex-wrap", className)}
    >
      {starters?.map((starter, i) => (
        <Starter key={i} starter={starter} />
      ))}
    </div>
  );
}
